import angular from 'angular';
import noncompliantMembersComponent from './noncompliant-members.component';

export default angular.module('components.app.member-compliance.noncompliant-members', [])
  .component('noncompliantMembers', noncompliantMembersComponent)
  .name;



// WEBPACK FOOTER //
// ./components/app/admin/member-compliance/noncompliant-members/noncompliant-members.module.js